import WavyLoader from "components/v2/WavyLoader";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";

const SubscriptionCheckoutPageLoader = () => {
	return (
		<Container>
			<PaddingX>
				<div className="mt-4 md:mt-8 flex-1 pb-24 lg:pb-8">
					<div className="max-w-3xl mx-auto">
						<div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
							{/* Main Payment Content */}
							<div className="lg:col-span-3">
								<div className="bg-white rounded-lg border border-gray-200 p-5">
									<WavyLoader height={20} width={80} className="mb-4" />
									<div className="space-y-4">
										{/* Currency selector */}
										<div className="mb-4">
											<WavyLoader height={16} width={70} className="mb-2" />
											<div className="inline-flex gap-2 rounded-full p-1 bg-gray-100">
												<WavyLoader height={36} width={80} className="rounded-full" />
												<WavyLoader height={36} width={80} className="rounded-full" />
											</div>
										</div>

										{/* Payment method pills */}
										<div>
											<WavyLoader height={14} width={90} className="mb-1.5" />
											<div className="flex flex-wrap gap-1.5">
												<WavyLoader height={36} width={100} className="rounded-md" />
												<WavyLoader height={36} width={90} className="rounded-md" />
												<WavyLoader height={36} width={80} className="rounded-md" />
											</div>
										</div>

										{/* Payment form */}
										<div className="border border-gray-200 rounded-lg p-4 bg-gray-50/50">
											<WavyLoader height={120} width="100%" />
										</div>
									</div>
								</div>
							</div>

							{/* Order Summary Sidebar */}
							<div className="hidden lg:block lg:col-span-2">
								<div className="bg-gray-50 rounded-lg border border-gray-200 p-4 sticky top-4">
									<WavyLoader height={16} width={80} className="mb-3" />
									<div className="space-y-1.5">
										<div className="flex justify-between">
											<WavyLoader height={14} width={50} />
											<WavyLoader height={14} width={60} />
										</div>
										<div className="flex justify-between">
											<WavyLoader height={14} width={55} />
											<WavyLoader height={14} width={40} />
										</div>
									</div>
									<div className="border-t border-gray-200 mt-2.5 pt-2.5">
										<div className="flex justify-between">
											<WavyLoader height={16} width={40} />
											<WavyLoader height={16} width={60} />
										</div>
									</div>
									<div className="pt-3 mt-3 border-t border-gray-200">
										<WavyLoader height={14} width={120} className="mx-auto" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</PaddingX>
		</Container>
	);
};

export default SubscriptionCheckoutPageLoader;
